<button
  class="collapse-button"
  type="button"
  [class.collapse-button--cart]="isCart"
  [class.collapse-button--above]="isCartTaxes"
  [class.collapse-button--active]="isOpen"
  [ngClass]="buttonExtraClass"
  (click)="toggle()"
  [attr.aria-controls]="contentId"
  [attr.aria-expanded]="isOpen"
  [disabled]="disabled"
>
  {{ btnText }}
  <vtmn-play-icon
    *ngIf="iconName && isFooter"
    class="collapse-button__icon"
    [class.collapse-button__icon--footer]="isFooter"
    [name]="iconName"
    [height]="18"
    [width]="18"
  ></vtmn-play-icon>
  <button
    *ngIf="iconName && !isFooter"
    app-vtmn-play-icon-button
    type="button"
    [size]="vtmnPlayIconButtonSize.SMALL"
    [variant]="vtmnPlayIconButtonVariant.SECONDARY"
  >
    <vtmn-play-icon
      [name]="iconName"
      [height]="18"
      [width]="18"
      class="collapse-button__icon"
      [class.collapse-button__icon--footer]="isFooter"
    ></vtmn-play-icon>
  </button>
</button>

<div @toggle *ngIf="isOpen" [id]="contentId">
  <ng-content></ng-content>
</div>
